/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_Label_EpostaInputs */

const tr_onbilgi_s1_label_eposta = /** @type {(inputs: Onbilgi_S1_Label_EpostaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta:`)
};

const en_onbilgi_s1_label_eposta = /** @type {(inputs: Onbilgi_S1_Label_EpostaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const de_onbilgi_s1_label_eposta = /** @type {(inputs: Onbilgi_S1_Label_EpostaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail:`)
};

const ru_onbilgi_s1_label_eposta = /** @type {(inputs: Onbilgi_S1_Label_EpostaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эл. почта:`)
};

/**
* | output |
* | --- |
* | "Email:" |
*
* @param {Onbilgi_S1_Label_EpostaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_label_eposta = /** @type {((inputs?: Onbilgi_S1_Label_EpostaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_Label_EpostaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_label_eposta(inputs)
	if (locale === "de") return de_onbilgi_s1_label_eposta(inputs)
	if (locale === "ru") return ru_onbilgi_s1_label_eposta(inputs)
	return tr_onbilgi_s1_label_eposta(inputs)
});